import React, { useEffect, useState } from 'react';
import { axiosGetCall, axiosPostCall } from '../../../services/apisCall';
import Logger from '../../../lib/Logger';
const logger = new Logger("kycListTable");
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import { CustomMenu } from '../../../components/menu/customMenu';

import { PaginationTable } from '../../../components/tables/paginationTable';
// import TableFilters from './tableFilter';

import { TableCell, Box, List, ListItem, MenuItem, styled, useTheme, TextField, Button, Select} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { configFile } from '../../../config';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { Icon } from '@iconify/react';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { ConfirmDialog } from 'src/components/custom-dialog';
import moment from 'moment';
import Iconify from 'src/components/iconify';

const columns = [
    
    { id: 'host_id', label: 'Host Id', minWidth: 110, align: 'center' },
    { id: 'owner_id', label: 'Owner Id', minWidth: 110, align: 'center' },
    { id: 'token', label: 'Token', minWidth: 110, align: 'center' },
    { id: 'route', label: 'Route', minWidth: 110, align: 'center' },
    { id: 'post_url', label: 'Post Url', minWidth: 110, align: 'center' },
    { id: 'speed_per_minute', label: 'TPS', minWidth: 110, align: 'center' },
    { id: 'rabbit_mq_host', label: 'Host', minWidth: 200, align: 'center' },
    { id: 'rabbit_mq_port', label: 'Port', minWidth: 110, align: 'center' },
    { id: 'rabbit_mq_user', label: 'User', minWidth: 110, align: 'center' },
    { id: 'rabbit_mq_pass', label: 'Password', minWidth: 110, align: 'center' },
    { id: 'update_by', label: 'Update By', minWidth: 110, align: 'center' },
    { id: 'status', label: 'Status', minWidth: 110, align: 'center' },
    { id: 'actions', label: 'Actions', minWidth: 70, align: 'center' }


];
const mockData = [
  {
    id: 1,
    host_id: "H001",
    owner_id: "O101",
    token: "abc123xyz",
    route: "promotional",
    post_url: "https://api.example.com/post",
    tps: 50,
    host: "server1.example.com",
    port: 8080,
    user: "admin1",
    password: '15151515',
    update_by: "system",
    status: 1,
  },
  {
    id: 2,
    host_id: "H002",
    owner_id: "O102",
    token: "def456uvw",
    route: "transactional",
    post_url: "https://api.example.com/send",
    tps: 100,
    host: "server2.example.com",
    port: 443,
    user: "admin2",
    password: "54545454",
    update_by: "john.doe",
    status: 0
  },
  {
    id: 3,
    host_id: "H003",
    owner_id: "O103",
    token: "ghi789rst",
    route: "otp",
    post_url: "https://api.example.com/otp",
    tps: 20,
    host: "server3.example.com",
    port: 3000,
    user: "admin3",
    password: '87878787',
    update_by: "jane.smith",
    status: 0,
  },
]

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
    // color: theme.palette.grey[200],
    gap: '8px'
}))
const menuItems = [
  { value: 0, label: 'Inactive', id: '101' },
  { value: 1, label: 'Active', id: '102' },
];

export const VoiceHostList = ({loadit, setUpdateUserId, forceLoad}) => {
    const theme = useTheme();
    const { URL_MAPPER: { console: consoleUrl } = {} } = configFile
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [rows, setRows] = useState([])
    const [count, setCount] = useState(0)

    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(true)
    const [networkError, setNetworkError] = useState(false)
    const [loading, setLoading] = useState(true);
    const [openStatus, setOpenStatus] = useState(false);
    const [status , setStatus] = useState()
    const [userData, setUserData] = useState([]);
    const [openAssign, setOpenAssign] = useState(false);
    const [assign , setAssign] = useState()


    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);


    
    const handleChange = (value) => setSearch(value)
    
    const getHostList = async () => {
        const skip = rowsPerPage * page;
        try {
            const params = { skip, limit: rowsPerPage }
            if (search) params.search = search
            setNetworkError(false)
            const { hostList, totalHostCount } = await axiosGetCall("getVoiceHostList", params)
            setRows(hostList);
            setCount(totalHostCount)
        } catch (error) {
            logger.error("Gateway List", error);
            setNetworkError(true)
            setRows([])
            setCount(0)
            renderErrorMessage(error?.message)
        }
        setLoading(false)
    }

    useEffect(() => {
        // if (load) {
            setLoading(true)
            getHostList()
            setLoad(false)
            forceLoad(false)

        // }
    }, [load,loadit])

    const handleClick = (event, user) => {
        setAnchorEl(event.currentTarget);
        setUserData(user);
    };
    const handleUpdateClick = () => {
        setAnchorEl(null);
        setUpdateUserId(userData.host_id);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleCloseStatus = () => {
         setAnchorEl(null);
        setOpenStatus(false);
        setStatus();
    };
    const handleStatusClick = () =>{
        setOpenStatus(true);
        setAnchorEl(null);
    };
        const handleAssignClick = () =>{
        setOpenAssign(true);
        setAnchorEl(null);
    }
    const handleCloseAssign = () => {
        setAnchorEl(null);
        setOpenAssign(false);
        setAssign();
    }
    const handleConfirmStatus = async(hostId, status) => {
        try{
            const params = {
                hostId,
                newStatus: status,
            }
            const data = await axiosGetCall('changeHostStatus', params)
            renderSuccessMessage(data?.message)
            getHostList();
            setOpenStatus(false);
            setAnchorEl(null);
            setStatus();
        } catch (error) {
            logger.error("Gateway List change status", error);
            renderErrorMessage(error?.message)
        }
        
    }

    const ActionJsx = (id, align, value, ...other) => {
        const user = other[3]

        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    color: 'grey.400',
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                    size: 'small'
                }}>
                <MoreVertIcon
                    sx={{ color: 'grey.700', cursor: 'pointer', height: '18px', width: '18px' }}
                    aria-controls={open ? 'filters-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={(e) => handleClick(e, user)}
                />
            </TableCell>
        )
    }
    const Content = () => (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
        }}>
            <List>
                <ListItem sx={{
                    display: 'flex',
                    gap: '7px',
                    fontWeight: 400,
                    color: 'grey.700',
                    '&:hover': {
                        color: 'grey.800',
                        backgroundColor: 'grey.300',
                        cursor: "pointer"
                    }
                }}
                    onClick={handleStatusClick}
                >
                    <SwapHorizIcon sx={{ color: '#1976d2', height: '17px', margin: '5px' }} />
                    Change Status
                </ListItem>
                <ListItem sx={{
                    display: 'flex',
                    gap: '7px',
                    fontWeight: 400,
                    color: 'grey.700',
                    '&:hover': {
                        color: 'grey.800',
                        backgroundColor: 'grey.300',
                        cursor: "pointer"
                    }
                }}
                    onClick={handleUpdateClick}
                >
                    <Icon icon="lucide:edit" style={{ color: '#1976d2', height: '17px', margin: '5px' }} />
                    Update
                </ListItem>
            </List>
        </Box>
    )

    const statusjsx = (id, align, value, ...other) => {
        let label = '';
        let boxStyles = {};

        if (value === 0) {
            label = 'Inactive';
            boxStyles = {
                color: '#D19244',
                backgroundColor: 'rgba(209, 146, 68, 0.20)',
            };
        } else if (value === 1) {
            label = 'Active';
            boxStyles = {
                color: '#50AB64',
                backgroundColor: 'rgba(40, 167, 69, 0.20)',
            };
        }

        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                    background: 'transparent',
                }}
            >
                <Box
                    sx={{
                        borderRadius: '6px',
                        fontWeight: 600,
                        fontSize: '14px',
                        display: 'inline-block',
                        ...boxStyles,
                        px: '12px',
                        py: '2px',
                    }}
                >
                    {label}
                </Box>
            </TableCell>
        );
    };
    const dedicatedJsx = (id, align, value, row) => {
    let tooltipText = '';
    let label = value === 1 ? <InfoIcon /> : '-';
    if (value === 1) {
        if (Array.isArray(row.d_user_id) && row.d_user_id.length > 0) {
            tooltipText = `Dedicated to: ${row.d_user_id.join(', ')}`;
        } else {
            tooltipText = 'Dedicated gateway';
        }
    }
    


    return (
        <TableCell
            key={id}
            align={align}
            sx={{
                borderBottom: '0.5px dashed',
                borderColor: 'grey.300',
                background: 'transparent',
            }}
        >
            <Tooltip title={tooltipText} arrow>
                    {label}
            </Tooltip>
        </TableCell>
    );
};
const createdatejsx = (id, align, value) => {
          const date = moment(Number(value));
        const formattedDate = date.format('D MMM, YYYY');
        const formattedTime = date.format('h:mm A');
        return (
            <TableCell
                key={id}
                align={align}
                sx={{
                    color: 'grey.700',
                    borderBottom: '0.5px dashed',
                    borderColor: 'grey.300',
                }}>
                <>
                    <Box>{value !== '' ? `${formattedDate} ${formattedTime}` : '-'}</Box>
                </>
            </TableCell>
        );
};
const routeJsx = (id, align, value) => {
    const ROUTE_LABELS = {
    transactional: "Transactional",
    promotional: "Promotional",
    explicit: "Explicit",
    implicit: "Implicit"
};
    const label = ROUTE_LABELS[value] || value;

    return (
        <TableCell
            key={id}
            align={align}
            sx={{
                borderBottom: '0.5px dashed',
                borderColor: 'grey.300',
                background: 'transparent',
            }}
        >
            {label}
        </TableCell>
    );
};

const passwordjsx = (id, align, value) => {
  const handleClick = () => {
    navigator.clipboard.writeText(value);
    renderSuccessMessage("Password copied to clipboard!");
  };

  return (
    <TableCell
      key={id}
      align={align}
      sx={{
        color: 'grey.700',
        borderBottom: '0.5px dashed',
        borderColor: 'grey.300',
        cursor: 'pointer',
      }}
      onClick={handleClick}
    >
      <Iconify
        icon="prime:copy"
        width="20px"
        color={theme.palette.primary.main}
      />
    </TableCell>
  );
};


    const ActionModals = () => {
        return (
            <CustomMenu
                anchorEl={anchorEl}
                handleClose={handleClose}
                Content={Content}
                 />
        )
    }
    return (
        <>
            <PaginationTable
                page={page}
                // tableFilter={tableFilter}
                ActionJsx={ActionJsx}
                ActionModals={ActionModals}
                setLoad={setLoad}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                count={count}
                error={networkError}
                loading={loading}
                setLoading={setLoading}
                rows={rows}
                columns={columns}
                handleChange={handleChange}
                search={search}
                calculatedHeight={288}
                status={statusjsx}
                dedicatedJsx={dedicatedJsx}
                routeJsx={routeJsx}
                createdatejsx={createdatejsx}
                passwordjsx={passwordjsx}
            />
            <ConfirmDialog
            open={openStatus}
            onClose={handleCloseStatus}
            title="Change Status"
            content={
            <span>
            Are you sure you want to change status this Gateway {userData.gateway_id}. 
            <Select
            id="change-status"
            defaultValue={userData.status}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            fullWidth
            sx={{
                marginTop: "10px",
                '& .MuiSelect-select': {
                paddingTop: '10px',
                paddingBottom: '10px',
                display: 'flex',
                alignItems: 'center',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                padding: 0,
                },
            }}
            >
            {menuItems.map((item) => {
                return (
                <MenuItem
                    key={item.value}
                    value={item.value}
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                >
                    <span>{item.label}</span>
                </MenuItem>
                );
            })}
            </Select>

            </span>
            }
            action={
              <Button
                color="secondary"
                variant="contained"
                sx={{
                    color: '#fff',
                    height: '30px',
                    backgroundColor: 'primary.main',
                    '&:hover': {
                        backgroundColor: 'primary.main',
                    },
                    boxShadow: "none",
                    marginRight: '10px'
                }}
                    onClick={() => handleConfirmStatus(userData.host_id, status)}
                    >Confirm
            </Button>
            }
          />
              <ConfirmDialog
                      open={openAssign}
                      onClose={handleCloseAssign}
                      title="Assign Gateway"
                      content={
                      <span>
                          Are you sure you want to assign this Gateway {userData.gateway_id} to user.
                          <TextField
                          required
                          id="outlined-required"
                          label="User ID"
                          multiline
                          maxRows={4}
                          fullWidth
                          value={assign}
                          onChange={(e) => setAssign(e.target.value)}
                          sx={{ marginTop: "10px" }}
                          />
                      </span>
                      }
                      action={
                        <Button
                          color="secondary"
                          variant="contained"
                          sx={{
                              color: '#fff',
                              height: '30px',
                              backgroundColor: 'primary.main',
                              '&:hover': {
                                  backgroundColor: 'primary.main',
                              },
                              boxShadow: "none",
                              marginRight: '10px'
                          }}
                            onClick={() => handleConfirmAssign(userData.gateway_id, assign)}
                              >Confirm
                      </Button>
                      }
                    />
        </>
    )
}
